<div *ngIf="plugin" class="ir-area ir-mask th-mask">
  <form class="ir-modal th-modal" novalidate="" [formGroup]="editForm" (ngSubmit)="save(editForm.value)">
    <modal-header [plugin]="plugin" [menuModal]="menuModal"></modal-header>
    <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
      <div
        class="ir-content--modal th-content th-content-customer"
        formArrayName="comments"
        *ngFor="let item of formData.controls; let i = index"
      >
        <table class="ir-modal-table">
          <tr>
            <td></td>
            <td class="th-plugin-line--remove th-plugin-line--remove-customer" colspan="2" align="right">
              <i class="material-icons" (click)="openValueDeleteConfirm(i)">remove_circle</i>
            </td>
          </tr>
          <tr>
            <td class="margin-big">
              <h2>
                <span style="margin-left: 10px"
                  >{{ 'plugins.installationcustomercomments.from-source' | translate }} *</span
                >
              </h2>
            </td>
            <td class="margin-big" style="width: 50%" [formGroupName]="i">
              <div class="ir-form-group">
                <p
                  class="ir-required th-required visible"
                  [class.visible]="
                    !item.controls.From.value || item.controls.From.value === 0 || item.controls.From.value === -1
                  "
                >
                  <span>{{ 'common.required' | translate }}</span>
                </p>
                <input type="hidden" class="ir-form-set" formControlName="From" />
                <div class="ir-line ir-select th-select" (click)="openFromSelector(item.controls.From.value, i)">
                  <div class="ir-line--right">
                    <div class="ir-btn th-btn-modal--content">
                      <i class="material-icons">arrow_drop_down</i>
                    </div>
                  </div>
                  <div class="ir-line-content">
                    <span>{{
                      item.controls.From.value && item.controls.From.value >= 0
                        ? (item.controls.From.value | customercommentfrom)
                        : ('plugins.installationcustomercomments.select-from' | translate)
                    }}</span>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </table>
        <h2>
          <span>{{ 'plugins.installationcustomercomments.comment' | translate }} *</span>
        </h2>
        <div class="ir-form-group" [formGroupName]="i">
          <p class="ir-required th-required visible" [class.visible]="!item.controls.Comment.value">
            <span>{{ 'common.required' | translate }}</span>
          </p>
          <angular-editor
            style="width: 100%"
            name="Comment"
            class="ir-form-set ir-form-set_freetext angular-editor"
            formControlName="Comment"
            [config]="config"
          ></angular-editor>
        </div>
      </div>
      <div class="ir-content--modal th-content th-content-plus">
        <table class="ir-modal-table">
          <tr class="th-plugin-line--add th-plugin-line--add-customer">
            <td colspan="4">
              <i class="material-icons" (click)="add()">add_circle</i>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <modal-footer [editForm]="editForm" [processing]="processing"></modal-footer>
  </form>
</div>
<modal #menuModal (modalOutput)="selectMenu($event)"></modal>
<modal
  (modalOutput)="selectCommentFromTargetsMenu($event)"
  (modalClosed)="onClose($event)"
  #commentFromTargetsModal
></modal>
<confirm
  #valueDeleteConfirm
  (confirmOutput)="remove($event)"
  [title]="'common.delete-confirmation' | translate"
  [message]="'Are you sure to delete this <strong>record</strong>?'"
  [danger]="true"
></confirm>
<confirm
  #pluginDeleteConfirm
  (confirmOutput)="deletePlugin()"
  [title]="'common.delete-confirmation' | translate"
  [message]="'plugins.sure-to-delete' | translate"
  [danger]="true"
></confirm>
